/* El archivo del cliente · Imprimirlo
 *
 * Todo lo que hay que hacer con un archivo subido, en un sitio: leerlo, medir
 * su resolución de verdad, saber si trae fondo, arreglarlo y poder deshacerlo.
 *
 * Nace de subida-dtf.js, que lleva meses haciendo esto bien en los transfers.
 * Lo saco aparte porque la ficha de ropa necesita lo mismo, y duplicarlo sería
 * repetir el error de hoy: arreglar "quitar el fondo" en un sitio y que en el
 * otro no salga. Las fichas de transfers y pegatinas se migrarán aquí cuando
 * haya un motivo; hoy funcionan y están probadas, así que no se tocan.
 */
(function () {
  'use strict';

  var A = {};

  A.dpiDe = async function (file) {
    var b = new DataView(await file.slice(0, 65536).arrayBuffer()), n = b.byteLength, d = null;
    if (n > 33 && b.getUint32(0) === 0x89504E47) {
      for (var i = 8; i + 12 <= n;) {
        var len = b.getUint32(i), tipo = b.getUint32(i + 4);
        if (tipo === 0x70485973 && b.getUint8(i + 16) === 1) { d = b.getUint32(i + 8) * 0.0254; break; }
        if (tipo === 0x49444154) break;
        i += 12 + len;
      }
    } else if (n > 20 && b.getUint16(0) === 0xFFD8 && b.getUint16(2) === 0xFFE0 && b.getUint32(6) === 0x4A464946) {
      var u = b.getUint8(13), x = b.getUint16(14);
      d = u === 1 ? x : u === 2 ? x * 2.54 : null;
    }
    return d && d > 100 && d < 1500 && Math.abs(d - 96) > 1 ? d : null;
  };

  /* Lee el archivo y saca lo que importa: píxeles útiles (sin el margen
     transparente), si tiene fondo, y una miniatura para pintar. */
  A.leer = async function (file, extra) {
    var dato = { file: file, name: file.name, px: null, transparente: null, arreglos: [] };
    if (extra) {
      dato.anterior = extra.anterior;
      dato.arreglos = extra.arreglos || [];
      /* Afinar amplía el archivo pero NO añade detalle: la calidad se sigue
         midiendo con los píxeles del original. Nada de maquillar. */
      if (dato.arreglos[dato.arreglos.length - 1] === 'bordes' && extra.anterior) {
        dato.pxCalidad = extra.anterior.pxCalidad || extra.anterior.px;
      }
    }
    if (!/png|jpe?g|webp/i.test(file.type)) return dato;
    /* TAMAÑO REAL (Xavi, 10/10): si el archivo trae su resolución (PNG pHYs
       o JPEG JFIF), el diseño mide lo que dice. 72/96 ppp son las de pantalla
       por defecto y no cuentan. */
    try { dato.dpiArchivo = await A.dpiDe(file); } catch (e) { dato.dpiArchivo = null; }
    try {
      var bmp = await createImageBitmap(file);
      var W = bmp.width, H = bmp.height;
      var escala = Math.min(1, Math.sqrt(4e6 / (W * H)));
      var cw = Math.max(1, Math.round(W * escala)), ch = Math.max(1, Math.round(H * escala));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(bmp, 0, 0, cw, ch);
      var d = ctx.getImageData(0, 0, cw, ch).data;
      var minX = cw, minY = ch, maxX = -1, maxY = -1, transp = false;
      for (var y = 0; y < ch; y++) for (var x = 0; x < cw; x++) {
        var a = d[(y * cw + x) * 4 + 3];
        if (a < 250) transp = true;
        if (a >= 8) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
      }
      if (maxX < 0) { if (bmp.close) bmp.close(); throw new Error('la imagen está vacía.'); }
      /* MARGEN LISO FUERA (Xavi, 26/09: «en las camisetas también debería
         cropar, así se adapta mejor a la zona de impresión»). Un JPG con
         margen blanco o negro ocupaba la zona entera con margen y el dibujo
         salía pequeño. Las sondas del fondo miran el archivo con su margen. */
      var pre = { x: minX, y: minY, X: maxX, Y: maxY };
      if (!transp && window.ImgArreglo && ImgArreglo.margenLiso) {
        var mg = ImgArreglo.margenLiso(d, cw, ch);
        if (mg) { minX = mg.x; minY = mg.y; maxX = mg.X; maxY = mg.Y; dato.margenQuitado = true; }
      }
      var caja = {
        x: Math.floor(minX / escala), y: Math.floor(minY / escala),
        w: Math.ceil((maxX + 1 - minX) / escala), h: Math.ceil((maxY + 1 - minY) / escala)
      };
      var t = Math.min(1, 420 / Math.max(caja.w, caja.h));
      var th = document.createElement('canvas');
      th.width = Math.max(1, Math.round(caja.w * t));
      th.height = Math.max(1, Math.round(caja.h * t));
      th.getContext('2d').drawImage(bmp, caja.x, caja.y, caja.w, caja.h, 0, 0, th.width, th.height);
      var tp = th;
      if (dato.margenQuitado) {
        var cp = { x: Math.floor(pre.x / escala), y: Math.floor(pre.y / escala),
          w: Math.ceil((pre.X + 1 - pre.x) / escala), h: Math.ceil((pre.Y + 1 - pre.y) / escala) };
        var tt = Math.min(1, 420 / Math.max(cp.w, cp.h));
        tp = document.createElement('canvas');
        tp.width = Math.max(1, Math.round(cp.w * tt)); tp.height = Math.max(1, Math.round(cp.h * tt));
        tp.getContext('2d').drawImage(bmp, cp.x, cp.y, cp.w, cp.h, 0, 0, tp.width, tp.height);
      }
      if (bmp.close) bmp.close();
      dato.px = [caja.w, caja.h];
      dato.caja = caja;
      dato.transparente = transp;
      dato.thumb = th;
      if (window.ImgArreglo) {
        dato.plano = ImgArreglo.esPlano(th);
        // ¿viene sobre un rectángulo negro? Entonces se puede fundir con la prenda
        dato.sobreNegro = ImgArreglo.pideFundirNegro(tp);
        dato.parteOscura = ImgArreglo.parteOscura ? ImgArreglo.parteOscura(th) : 0;
        if (ImgArreglo.pareceMockup) {
          try { var mk = ImgArreglo.pareceMockup(tp, file.name); dato.mockup = !!(mk && mk.mockup); } catch (e2) { dato.mockup = false; }
        }
      }
    } catch (e) {
      if (e && e.message && /vacía/.test(e.message)) throw e;
      /* si no se puede leer, se sube igual: un PDF o un AI no se analizan
         aquí y no por eso hay que impedir la compra */
    }
    return dato;
  };

  /* EL ARCHIVO QUE VA AL TALLER. Si se le ha quitado un margen liso, o se ha
     fundido el negro, va el ORIGINAL (con su fondo: Xavi, 26/09, «transparente
     no me sirve para nada», el fundido y la trama los hace su panel),
     recortado a lo que se ha medido, sin remuestrear, y con la medida escrita
     dentro del PNG. Si no, o si algo falla, va el archivo tal cual. */
  A.archivoTaller = async function (dato, mmW, maxMb) {
    var tal = { file: dato.file, name: dato.name };
    var conNegro = (dato.arreglos || []).indexOf('negro') !== -1;
    if (!dato.caja || !(conNegro || dato.margenQuitado) || !window.ImgArreglo || !ImgArreglo.pngConMedida) return tal;
    var ori = dato;
    while (ori.anterior && (ori.arreglos || []).indexOf('negro') !== -1) ori = ori.anterior;
    if (!ori.file) return tal;
    if (conNegro) tal = { file: ori.file, name: ori.name };
    try {
      var bo = await createImageBitmap(ori.file), cj = dato.caja;
      var lz = document.createElement('canvas');
      lz.width = cj.w; lz.height = cj.h;
      lz.getContext('2d').drawImage(bo, cj.x, cj.y, cj.w, cj.h, 0, 0, cj.w, cj.h);
      if (bo.close) bo.close();
      var cm = function (v) { return (Math.round(v / 10 * 10) / 10).toString().replace('.', '_'); };
      var nom = ori.name.replace(/\.[^.]+$/, '') + (conNegro ? '-original-' : '-') +
        (mmW ? cm(mmW) + 'x' + cm(mmW * cj.h / cj.w) + 'cm' : 'recortado') + '.png';
      var f = await ImgArreglo.pngConMedida(lz, mmW || cj.w / 300 * 25.4, nom);
      if (!maxMb || f.size <= maxMb * 1048576) tal = { file: f, name: nom };
    } catch (e) { /* se queda el de antes */ }
    return tal;
  };

  // ancho en cm al que ese archivo se ve nítido a los ppp que se le pidan
  A.anchoNitido = function (dato, ppp) {
    var px = (dato.pxCalidad || dato.px);
    return px ? px[0] / ((ppp || 250) / 2.54) : 0;
  };

  /* Arreglos. Devuelve el dato NUEVO ya leído, o null si no había nada que
     hacer. El que llama decide qué enseña y cuándo. */
  A.arreglar = async function (dato, tipo, maxMb, mmW) {
    if (!dato || !dato.px || !window.ImgArreglo) return null;
    var bmp = await createImageBitmap(dato.file);
    var lienzo = document.createElement('canvas');
    lienzo.width = bmp.width; lienzo.height = bmp.height;
    lienzo.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0);
    if (bmp.close) bmp.close();
    var res = tipo === 'fondo' ? ImgArreglo.quitarFondo(lienzo)
      : tipo === 'negro' ? ImgArreglo.fundirNegro(lienzo)
      : ImgArreglo.afinarBordes(lienzo, 3);
    if (!res.ok) return { ok: false, motivo: res.motivo || 'nada-que-hacer' };
    var base = dato.name.replace(/\.[^.]+$/, '');
    var sufijo = tipo === 'fondo' ? '-sin-fondo'
      : tipo === 'negro' ? '-sin-negro' : '-afinado';
    var nuevo = await ImgArreglo.aFichero(res.lienzo, base + sufijo + '.png');
    if (maxMb && nuevo.size > maxMb * 1048576) return { ok: false, motivo: 'pesa-demasiado' };
    var comp = null;
    try {
      comp = (tipo === 'negro' && ImgArreglo.vistaSemitono)
        ? ImgArreglo.vistaSemitono(lienzo, res.lienzo, mmW || 100, 420, 294)
        : ImgArreglo.comparar(lienzo, res.lienzo, 200, 140);
    } catch (e) { comp = null; }
    /* Copia ENTERA del dato de antes, no una lista de campos a mano.
       Con la lista se perdía lo que no estuviera escrito en ella: pasó con
       `sobreNegro`, y al deshacer el arreglo del fondo negro la ficha ya no
       sabía que el archivo venía sobre negro, así que ofrecía "quitar el
       fondo" y no se podía repetir. Copiando todo, cualquier marca que se
       añada en el futuro sobrevive al deshacer sin tener que acordarse. */
    var anterior = {};
    Object.keys(dato).forEach(function (k) { anterior[k] = dato[k]; });
    anterior.arreglos = (dato.arreglos || []).slice();
    var out = await A.leer(nuevo, { anterior: anterior, arreglos: anterior.arreglos.concat([tipo]) });
    out.anterior = anterior;
    out.comparativa = comp;
    return { ok: true, dato: out };
  };

  A.deshacer = function (dato) {
    return (dato && dato.anterior) ? dato.anterior : dato;
  };

  /* ¿Se le va a perder el logo encima de esa prenda?
   *
   * El DTF de Imprimirlo lleva SIEMPRE blanco de base, así que un logo de
   * colores sobre una prenda oscura sale perfecto. El único problema real es
   * que la tinta del logo sea del mismo color que la prenda: negro sobre
   * negra, blanco sobre blanca. Así que no se mide brillo, se mide distancia
   * de color, y solo se avisa cuando una parte gorda del dibujo se camufla.
   *
   * Devuelve la fracción (0..1) del logo que se confunde con la prenda.
   */
  function aRgb(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return null;
    var n = parseInt(h, 16);
    if (isNaN(n)) return null;
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  // distancia de color "redmean": barata y se parece bastante a cómo vemos
  function dist(a, b) {
    var rm = (a[0] + b[0]) / 2;
    var dr = a[0] - b[0], dg = a[1] - b[1], db = a[2] - b[2];
    return Math.sqrt((2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db);
  }

  /* El fondo no cuenta. Un logo de colores con fondo blanco sobre camiseta
     blanca se ve perfectamente: el fondo se funde con la prenda y ya está.
     Lo grave es que la TINTA sea del color de la prenda. Así que primero se
     separa el fondo —lo que se alcanza desde el borde— y se mide solo el
     dibujo. Es la misma idea que usa quitarFondo, aquí solo para medir. */
  function marcarFondo(d, w, h) {
    var n = w * h, fondo = new Uint8Array(n), i, x, y, p;
    var borde = [];
    for (x = 0; x < w; x++) { borde.push(x); borde.push((h - 1) * w + x); }
    for (y = 1; y < h - 1; y++) { borde.push(y * w); borde.push(y * w + w - 1); }

    /* Si el logo viene con transparencia, el fondo YA está separado: no hay
       nada que rellenar y todo lo opaco es dibujo. Rellenar aquí sería
       comerse las letras que tocan el borde del recorte. */
    var huecos = 0;
    for (i = 0; i < borde.length; i++) if (d[borde[i] * 4 + 3] < 128) huecos++;
    if (huecos > borde.length * 0.2) {
      for (p = 0; p < n; p++) if (d[p * 4 + 3] < 128) fondo[p] = 1;
      return fondo;
    }

    // opaco de borde a borde: el fondo es el color que más se repite en el borde
    var cubos = {}, mejor = null, mejorN = 0;
    for (i = 0; i < borde.length; i++) {
      p = borde[i];
      var k = (d[p * 4] >> 4) + ',' + (d[p * 4 + 1] >> 4) + ',' + (d[p * 4 + 2] >> 4);
      cubos[k] = (cubos[k] || 0) + 1;
      if (cubos[k] > mejorN) { mejorN = cubos[k]; mejor = [d[p * 4], d[p * 4 + 1], d[p * 4 + 2]]; }
    }
    if (!mejor) return fondo;

    var pila = [];
    for (i = 0; i < borde.length; i++) {
      p = borde[i];
      if (!fondo[p] && dist([d[p * 4], d[p * 4 + 1], d[p * 4 + 2]], mejor) < 60) { fondo[p] = 1; pila.push(p); }
    }
    while (pila.length) {
      p = pila.pop();
      x = p % w; y = (p - x) / w;
      var vecinos = [];
      if (x > 0) vecinos.push(p - 1);
      if (x < w - 1) vecinos.push(p + 1);
      if (y > 0) vecinos.push(p - w);
      if (y < h - 1) vecinos.push(p + w);
      for (i = 0; i < vecinos.length; i++) {
        var q = vecinos[i];
        if (fondo[q]) continue;
        if (dist([d[q * 4], d[q * 4 + 1], d[q * 4 + 2]], mejor) < 60) { fondo[q] = 1; pila.push(q); }
      }
    }
    /* Red de seguridad: si el relleno se ha llevado casi todo, es que el fondo
       y el dibujo son del mismo color y no hay nada que separar. Mejor no
       separar nada que medir sobre cuatro píxeles. */
    var fuera = 0;
    for (p = 0; p < n; p++) if (fondo[p]) fuera++;
    if (fuera > n * 0.95) return new Uint8Array(n);
    return fondo;
  }

  A.camuflaje = function (dato, hexPrenda) {
    var prenda = aRgb(hexPrenda);
    if (!dato || !dato.thumb || !prenda) return 0;
    try {
      var c = dato.thumb, w = c.width, h = c.height;
      var d = c.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
      var fondo = marcarFondo(d, w, h);
      var tinta = 0, perdidos = 0;
      for (var p = 0; p < w * h; p++) {
        if (fondo[p] || d[p * 4 + 3] < 128) continue;
        tinta++;
        if (dist([d[p * 4], d[p * 4 + 1], d[p * 4 + 2]], prenda) < 130) perdidos++;
      }
      return tinta ? perdidos / tinta : 0;
    } catch (e) { return 0; }
  };

  /* CÓMO SE LLAMA CADA ARREGLO, en un solo sitio.
   *
   * Estaba repetido en cada ficha —ropa, packs, DTF, tarjetas—, así que añadir
   * un arreglo nuevo obligaba a tocar cinco ficheros y a acordarse de los
   * cinco. Ahora la ficha pregunta en vez de repetir.
   *
   *   boton   lo que lee el cliente
   *   pedido  lo que lee Xavi en el albarán, que a veces es una INSTRUCCIÓN de
   *           producción y no solo una descripción
   */
  A.ARREGLOS = {
    fondo: { boton: 'Quitar el fondo', pedido: 'fondo quitado en la web' },
    bordes: { boton: 'Afinar los bordes', pedido: 'bordes afinados en la web' },
    /* «El fondo negro es la prenda» era una frase nuestra, no suya: describe lo
       que pasa por dentro. Raquel, en el pedido IMP#1936, escribió un párrafo
       entero para preguntar si eso era lo que ella quería —y lo era—. Su
       palabra era RECUADRO: «el recuadro no, que se vea solo logo y letras».
       Así que el botón dice lo que hace, con la palabra que usa quien compra. */
    /* 26/09: Xavi lo renombra a «Eliminar negro de fondo» al retirar el
       quitafondos genérico, para que el que venía buscando «quitar el fondo»
       encuentre este, que es el que sí funciona. Se pierde la palabra de
       Raquel y se gana la que teclea el cliente al llegar.
       Y el mismo día, «+ semitono»: lo quiere vender como ventaja, así que
       el botón dice también lo que gana. Sigue empezando por «Eliminar negro». */
    negro: { boton: 'Eliminar negro + semitono',
             /* Al taller va el ORIGINAL con su fondo: el fundido y la trama
                los hace su panel (Xavi, 26/09). */
             pedido: 'va el ORIGINAL con su fondo — FUNDIR negro + TRAMAR puntos45' }
  };
  A.boton = function (t) { return (A.ARREGLOS[t] || {}).boton || t; };
  A.pedido = function (t) { return (A.ARREGLOS[t] || {}).pedido || t; };

  /* Qué arreglos tiene sentido ofrecer con este archivo a este tamaño.
   *
   * "sinFondo" lo pone la ficha: es TRUE cuando el fondo no se imprime porque
   * es la prenda (ropa, packs, transfer DTF) y FALSE cuando el fondo sí se
   * imprime (tarjetas, pegatinas). En una tarjeta el negro es tinta que el
   * cliente ha pedido; quitarlo sería estropearle el diseño. */
  A.sugerencias = function (dato, anchoCm, pppBueno, sinFondo) {
    if (!dato || !dato.px) return [];
    var hechos = dato.arreglos || [], out = [];
    /* Si el arte viene sobre un rectángulo negro, el arreglo bueno es fundir
       ese negro con la prenda, y entonces NO se ofrece además "quitar el
       fondo": sería la versión mala de lo mismo. Recortar un fondo plano deja
       un borde duro justo donde el dibujo se estaba apagando. */
    /* 26/09: el semitono se ofrece siempre que haya negro en el diseño, haga
       recuadro o no (≥5 % oscuro), igual que en transfers. */
    var negro = sinFondo !== false && hechos.indexOf('negro') === -1 &&
      (dato.sobreNegro || (dato.parteOscura || 0) >= 0.05);
    if (negro) out.push('negro');
    else if (dato.transparente === false && hechos.indexOf('fondo') === -1 && hechos.indexOf('negro') === -1) out.push('fondo');
    var nitido = A.anchoNitido(dato, pppBueno || 250);
    /* Afinar NO después del semitono: su curva sobre el alfa se come el
       degradado que el taller tiene que tramar. */
    if (hechos.indexOf('bordes') === -1 && hechos.indexOf('negro') === -1 &&
        dato.px[0] <= 1500 && anchoCm && nitido < anchoCm) out.push('bordes');
    return out;
  };

  window.Archivo = A;
})();